import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

import { PoReportDto } from './po-report.dto';


export class PoReportResponseModel extends GlobalResponseObject {
    data?: PoReportDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: PoReportDto[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}

